module.exports = __webpack_public_path__ + "img/a8786fe97faa73cac8aad05361833b7d.png";